import { Link } from "react-router-dom";

import { BRAND } from "@/config/brand";

/*
 * Definitive brand logo (client asset, self-hosted).
 * Source PNG is 1272x351 (trimmed) — rendered small against its natural
 * size so it stays crisp on retina displays.
 */
export const Wordmark = ({ className = "", to = "/", size = "md" }) => (
  <Link
    to={to}
    data-testid="brand-wordmark"
    className={`inline-flex items-center select-none ${className}`}
    aria-label={BRAND.name}
  >
    <img
      src={BRAND.logo}
      alt={BRAND.name}
      className={size === "sm" ? "h-[18px] w-auto" : "h-7 w-auto"}
      draggable={false}
    />
  </Link>
);
